import { Route } from 'types/route.type';
import SiteOverview from 'views/playground/features/my-supply-plan/components/site-overview';

export const routes: Route[] = [
  {
    path: '/playground/supply-plan/order-free-delivery/:siteErpId/:globalSiteId/:sectionTab?',
    component: SiteOverview,
  },
];
